import cn from 'classnames';
import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { LegacyButtonVariant } from 'apps/sigma2-ui/src/components/ui/Buttons';
import { getButtonClassName } from 'apps/sigma2-ui/src/components/ui/Buttons';

type ButtonType = 'button' | 'submit' | 'reset';

type ButtonProps = React.HTMLProps<HTMLButtonElement> & {
  variant: LegacyButtonVariant;
  type?: ButtonType;
};

export const LegacyButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { variant, className: customClassName } = props;
    const language = useLanguage();

    const className = cn(
      getButtonClassName(variant, props.disabled),
      customClassName,
    );

    const conditionalProps = {
      title: props.disabled
        ? language.submitDisabledFillAllInputs()
        : undefined,
    };

    return (
      <button
        {...props}
        {...conditionalProps}
        ref={ref}
        className={className}
        type={props.type || 'button'}
      />
    );
  },
);

LegacyButton.displayName = 'LegacyButton';
